__turbopack_context__.v({
  "description": "ProducerDrawer-module-scss-module__5vEK8G__description",
  "drawer": "ProducerDrawer-module-scss-module__5vEK8G__drawer",
  "no-results": "ProducerDrawer-module-scss-module__5vEK8G__no-results",
  "producers": "ProducerDrawer-module-scss-module__5vEK8G__producers",
  "search": "ProducerDrawer-module-scss-module__5vEK8G__search",
  "title": "ProducerDrawer-module-scss-module__5vEK8G__title",
});
